import React from 'react'

function BoltIcon({
  width = 11,
  height = 14,
  color = 'color(display-p3 0.7098 0.8784 0.9686)',
  opacity = 1,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      opacity={opacity}
      viewBox="0 0 11 14"
    >
      <path
        fill={color}
        d="M4.533 11.133L7.983 7H5.317L5.8 3.217l-3.083 4.45h2.316l-.5 3.466zm-1.7 2.534L3.5 9H.167l6-8.667H7.5l-.667 5.334h4l-6.666 8H2.833z"
      ></path>
    </svg>
  )
}

export default BoltIcon
